<template>
  <div class="content-wrapper">
    <section class="content">
      <div class="row" style="text-align: center;" >
        <div class="col-sm-12 col-lg-8 col-md-8 col-md-offset-2">
          <div class="panel panel-default">
            <div class="panel-body">
              <h1>Check In</h1>
              <p>"Festival Musik & Seni Outdoor Berkelas Dunia Pertama di Indonesia"</p>
              <form @submit.prevent="onSubmit" style="margin-top: 35px;">
                <div class="row">
                  <div class="col-md-6 col-md-offset-3">
                    <div :class="formValidation.wrisbandCode === '' ? 'form-group input-group-lg' : 'form-group input-group-lg has-error'">
                      <label style="color: #333333 !important;">Wrisband Code</label>
                      <input
                        v-model="wrisbandCode"
                        ref="wrisbandCodeRef"
                        type="text"
                        class="form-control"
                        placeholder="Wrisband code">
                        <span v-if="formValidation.wrisbandCode !== ''" class="help-block">{{ formValidation.wrisbandCode }} </span>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 15px;">
                  <button v-if="isLoading" type="button" class="btn btn-primary btn-flat" disabled> <ProgressLoader size="15"/> Loading...</button>
                  <button v-if="!isLoading" type="submit" class="btn btn-primary btn-flat">Check In</button>
                </div>
              </form>

              <Transition name="fade">
                {{ message }}
                <div style="margin-top: 15px;" v-if="message.shown">
                  <div :class="`alert alert-dismissible ${message.type}`" role="alert">
                    <button type="button" @click="onResetMessage()" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    {{ message.text }}
                  </div>
                </div>
              </Transition>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Circle } from 'vue-loading-spinner';

export default {
  components: {
    ProgressLoader: Circle,
  },
  data() {
    return {
      isLoading: false,
      wrisbandCode: null,
      message: {
        shown: false,
        text: '',
        type: '', // alert-danger alert-success
      },
      formValidation: {
        wrisbandCode: '',
      },
    };
  },
  mounted() {
    this.focusInput();
  },
  methods: {
    validateForm() {
      if (!this.wrisbandCode) {
        this.formValidation.wrisbandCode = 'Please field with valid voucher code';
        return false;
      }
      return true;
    },
    async onSubmit() {
      this.onResetMessage();
      const validation = this.validateForm();
      if (!validation) return;

      try {
        this.isLoading = true;
        const formData = new FormData();
        formData.append('wristband_code', this.wrisbandCode);

        const res = await this.axios.post('/ticketItems/checkin', formData);

        this.message.shown = true;
        this.message.text = res.data.message;
        this.message.type = 'alert-success';
      } catch (errors) {
        console.error('[ERR ONSUBMIT]', errors.response);
        this.message.shown = true;
        this.message.text = errors.response.data.errors;
        this.message.type = 'alert-danger';
      } finally {
        this.wrisbandCode = '';
        this.formValidation.wrisbandCode = '';
        this.isLoading = false;
        this.focusInput();
        // setTimeout(() => this.onResetMessage(), 5000);
      }
    },
    onResetMessage() {
      this.message.shown = false;
      this.message.text = '';
      this.message.type = '';
    },
    focusInput() {
      this.$refs.wrisbandCodeRef.focus();
    },
  },
};
</script>


<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.form-control {
  border-top: 0px !important;
  border-left: 0px !important;
  border-right: 0px !important;
  border-radius: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ticketing/checkin.vue